<template>
    <div class="introduction">
        <div class="icon">
            <img src="../../../assets/images/xhjj.jpg" alt="">
        </div>
        <div class="text">
            &emsp;&emsp;济南市历下区文化产业协会成立于2013年12月，是经民政局登记的非营利性社会团体， 是文化产业领域的协会。协会会员均为优秀的文化企事业单位，涉及影音像的制作、动漫游戏、设计创意等内容生产、文创产品研发化及旅游、文化金融、投资运营等领域，有着一定的影响力和引领示范作用。<br>
            &emsp;&emsp;文化产业协会以“服务会员、搭建平台、创新发展”为宗旨，以建设成为文化领域的知名社会组织为要求，着力建设跨界交流平台，形成相互融合、相互激发、相互促进的发展格局。
        </div>
    </div>
</template>

<script>
export default {
    name: 'Introduction',
    data() {
        return {
            
        }
    },
}
</script>

<style scoped>
.introduction{
    margin-top: .2rem;
    background: #fff;
    overflow: hidden;
}
.icon{
    text-align: center;
    margin-top: .56rem;
}
.icon img{
    width: 6rem;
}
.text{
    padding: .44rem .3rem 0;
    font-size: .28rem;
    line-height: 2;
}
</style>